import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=40fb587a&"
import script from "./UserPassword.vue?vue&type=script&lang=js&"
export * from "./UserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QBtn,QTooltip,QIcon} from 'quasar'
component.options.components = Object.assign({QInput,QBtn,QTooltip,QIcon}, component.options.components || {})
